import React from 'react';
import QueryClientProvider from 'src/components/QueryClientProvider/QueryClientProvider';

/**
 * Wrapper component that provides QueryClient context for form components
 * that use React Query hooks (useMutation, useQuery, etc.)
 *
 * Usage:
 * <WebFormWithQueryClient>
 *   <YourFormComponent />
 * </WebFormWithQueryClient>
 */
const WebFormWithQueryClient = ({ children }) => <QueryClientProvider>{children}</QueryClientProvider>;

export default WebFormWithQueryClient;
